import * as React from 'react'

import isEmpty from 'lodash-es/isEmpty'

import ItemCard from '../../itemCard'
import Scroll from '../../itemCard/photoduneGridItemCard/scrollContainer'
import ItemDetails from '../../itemDetails/itemDetailsContainer'
import GridStyles from './gridStyles'

import { buildItemClassName } from './buildItemClassName'
import { balanceRows } from './rowBalancer'

import { IItem } from '../../../../../typings/searchResults'

import * as styles from './grid.module.css'

interface IProps {
  items: IItem[]
  itemDecorator: any
  location: any
  selectedItemId: number
}

export interface IItemRow {
  id: number
  items: IItem[]
  size: number
}

const splitItemsIntoRows = (items: IItem[], itemsPerRow: number) => {
  if (isEmpty(items)) {
    return null
  }

  const rows = items.reduce<IItemRow[]>((accumulator, item) => {
    const currentRow = accumulator[accumulator.length - 1]
    const canAddToRow = accumulator.length > 0 && currentRow.size < itemsPerRow

    let { aspectRatio } = item.ui
    aspectRatio = aspectRatio || 1.0

    if (canAddToRow) {
      currentRow.items.push(item)
      currentRow.size += aspectRatio
      return accumulator
    }

    return [
      ...accumulator,
      {
        id: item.id,
        items: [item],
        size: aspectRatio
      }
    ]
  }, [])

  return balanceRows(rows, itemsPerRow)
}

const renderItems = (
  items: IItem[],
  itemDecorator: any,
  location: any,
  shouldScroll: boolean
) => {
  return items
    .filter(item => item.image_urls && item.image_urls.length > 0)
    .map((item, i) => {
      const itemClassNames = [
        buildItemClassName('item', item.id),
        styles.item
      ].join(' ')

      const itemDetailsClassName = buildItemClassName('details', item.id)

      const itemProps = itemDecorator(item, i)

      const prevItemId = items[i - 1] && items[i - 1].id
      const nextItemId = items[i + 1] && items[i + 1].id

      return (
        <div key={i} className={itemClassNames} data-test="gridItem">
          <Scroll itemId={item.id} shouldScroll={shouldScroll}>
            <ItemCard imageClassName={styles.image} {...itemProps} />
            <ItemDetails
              itemDetailsClassName={itemDetailsClassName}
              prevItemId={prevItemId}
              nextItemId={nextItemId}
              location={location}
              {...itemProps}
            />
          </Scroll>
        </div>
      )
    })
}

class Grid extends React.Component<IProps> {
  private shouldScroll = true

  public componentWillUpdate(nextProps: IProps) {
    this.shouldScroll = this.props.selectedItemId !== nextProps.selectedItemId
  }

  public render() {
    const { items, itemDecorator, location } = this.props

    return (
      <div className={styles.gridContainer}>
        <GridStyles
          rows={splitItemsIntoRows(items, 1)}
          itemsPerRow={1}
          minWidth={0}
          maxWidth={719}
        />
        <GridStyles
          rows={splitItemsIntoRows(items, 2)}
          itemsPerRow={2}
          minWidth={720}
          maxWidth={999}
        />
        <GridStyles
          rows={splitItemsIntoRows(items, 3)}
          itemsPerRow={3}
          minWidth={1000}
          maxWidth={1199}
        />
        <GridStyles
          rows={splitItemsIntoRows(items, 4)}
          itemsPerRow={4}
          minWidth={1200}
          maxWidth={0}
        />
        {renderItems(items, itemDecorator, location, this.shouldScroll)}
      </div>
    )
  }
}

export default Grid
